// extracted by mini-css-extract-plugin
export default {"Alert":"Alert_Alert__wnpDH","Alert__side":"Alert_Alert__side__XwMnr","Alert__content":"Alert_Alert__content__6dIOB"};